import React from 'react';
import { InteractionStatus } from '@azure/msal-browser';
import { IMsalContext, MsalContext } from '@azure/msal-react';
import { SmokeApi } from "../controller/SmokeApi";
import { WebApiInterop } from "../controller/WebApiInterop";
import { loginRequest } from '../authConfig';
import { ServiceReadings, ServiceReadingsSet } from "../model/Reading";
import { SmokeSummary } from "../model/SmokeSummary";
import { SmokeSummaryDetails } from '../components/SmokeSummaryDetails';
import { IAppContext } from "../model/IAppContext";
import { makeStyles } from '@fluentui/react-components';
import { withStylesAndContext, withStyles, withStylesAndMsalContext } from "../components/withStyles";
import { SiteHeaderWithoutStyles } from "../components/SiteHeader";
import { TheAppContext } from '../model/AppContext';
import { TrendGraph } from '../components/TrendGraph';

export interface HomePageProps
{
    styles: Record<string, string>;
    msalContext: IMsalContext;
    appContext?: IAppContext;
}

export interface HomePageState
{
    smokes: SmokeSummary[];
}

const useStyles = makeStyles(
    {
        latestContainer:
        {
            padding: '10pt'
        }
    });

export class HomePageWithoutStyles extends React.Component<HomePageProps, HomePageState>
{
    context!: IAppContext;
    static contextType = TheAppContext;

    constructor(props: HomePageProps)
    {
        super(props);
        this.state = {
            smokes: []
        };
    }

    buildSmokesFromServiceReadingsSet(readings: ServiceReadingsSet): SmokeSummary[]
    {
        if (readings.TheValue == null)
            return [];

        const smokes: Map<string, SmokeSummary> = new Map<string, SmokeSummary>();

        // the readings set is grouped by smoke...
        for (const readingSet of readings.TheValue)
        {
            if (readingSet.length == 0)
                continue;

            const smokeId = readingSet[0].SmokeID;
            let smoke = smokes.get(smokeId);

            if (!smoke)
            {
                smoke = new SmokeSummary();

                smoke.SmokeID = smokeId;
                smokes.set(smokeId, smoke);
            }

            // we want to reverse the order of the readings so most
            // recent is last...
            for (let idx = readingSet.length - 1; idx >= 0; idx--)
            {
                const reading = readingSet[idx];
                smoke.addReading(reading.Address, reading);
            }
        }

        const smokesArray: SmokeSummary[] = [];
        for (const smoke of smokes.values())
        {
            smokesArray.push(smoke);
        }

        return smokesArray;
    }

    async getLatestReadings()
    {
        const result: ServiceReadingsSet = await this.context.WebApi.getLatestReadingsSet();

        this.setState({ smokes: this.buildSmokesFromServiceReadingsSet(result) });
    }

    async componentDidMount()
    {
        await this.getLatestReadings();
    }

    render()
    {
        const loginInProgress = this.props.msalContext.inProgress === InteractionStatus.Startup || this.props.msalContext.inProgress === InteractionStatus.HandleRedirect;

        const smokes = this.state.smokes.map((smoke) => (<SmokeSummaryDetails key={smoke.SmokeID} smokeSummary={smoke}/>));

        const width = 110;
        const height = 60;
        const values = [150, 180, 190, 170, 140];
        const minTarget = 40;
        const maxTarget = 280;
        return (
            <div className={this.props.styles.latestContainer}>
                {smokes}
            </div>
        );
    }
}

export const HomePage = withStylesAndMsalContext(useStyles, HomePageWithoutStyles);